import React from 'react';

import PropTypes from 'prop-types';

// Material UI Imports
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Material Icons Imports
import IconVisibility from '@material-ui/icons/Visibility';
import IconSave from '@material-ui/icons/SaveAlt';
import IconArchive from '@material-ui/icons/ArchiveOutlined';

import axios from 'axios';
import Button from '@material-ui/core/Button';
import _ from 'lodash';
//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: 0,
    position: 'relative',

  },
  fabProgress: {
    position: 'absolute',
    top: 5,
    left: 5,
    zIndex: 0,
  },
})

class CertificateTableActions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  _createCertificateLinks(certificate, action) {
    const pdfUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/users/' + certificate.user.id + '/certificate/' + certificate.id
    console.log(pdfUrl)
    axios.get(pdfUrl,
      {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      })
      .then((response) => {
        const fileExtension = _.last(certificate.baseFileName.split('.'))
        console.log(fileExtension)
        let type;
        if (fileExtension === 'pdf') {
          type = 'application/pdf'
        } else {
          type = `image/${fileExtension}`
        }
        console.log(type)
        const url = window.URL.createObjectURL(new Blob([response.data],
          { type: type }));
        const link = document.createElement('a');
        link.href = url;
        const linkDownload = document.createElement('a');
        linkDownload.href = url;
        linkDownload.setAttribute('download', certificate.baseFileName);
        link.target = '_blank';
        document.body.appendChild(link);
        document.body.appendChild(linkDownload);
        this.setState({
          [`${certificate.id}-download`]: linkDownload,
          [`${certificate.id}-show`]: link,
          [`${action}ing`]: false
        })
        this.state[`${certificate.id}-${action}`].click()
      })
      .catch((error) => console.log(error));
  }

  _handleClickCertificate(certificate, action) {
    this.setState({ [`${action}ing`]: true })
    if (this.state[`${certificate.id}-${action}`]) {
      this.state[`${certificate.id}-${action}`].click()
      this.setState({ [`${action}ing`]: false })
    } else {
      this._createCertificateLinks(certificate, action)
    }
  }

  _handleArchive = async (certificate, handler) => {
    const certificateId = certificate.id;
    await this.props.mutationMarkAsDeleted({
      variables: {
        certificateId
      }
    })
      .catch((e) => {
        console.log(e)
      })
      .then(this.handleClose)
      .then(handler)
  }


  render() {

    const { showing, downloading, archiving } = this.state;
    const { classes, certificate, handler } = this.props;


    return (
      <div className={classes.root}>
        <Tooltip title="Show">
          <div className={classes.wrapper}>

            <IconButton onClick={this._handleClickCertificate.bind(this, certificate, 'show')}>
              <IconVisibility />
            </IconButton>
            {showing && <CircularProgress size={40} className={classes.fabProgress} />}
          </div>
        </Tooltip>
        <Tooltip title="Download">
          <div className={classes.wrapper}>
            <IconButton onClick={this._handleClickCertificate.bind(this, certificate, 'download')}>
              <IconSave />
            </IconButton>
            {downloading && <CircularProgress size={40} className={classes.fabProgress} />}
          </div>
        </Tooltip>
        <Tooltip title="Archive">
          <div className={classes.wrapper}>
            <IconButton onClick={this.handleClickOpen}>
              <IconArchive />
            </IconButton>
            {archiving && <CircularProgress size={40} className={classes.fabProgress} />}
          </div>
        </Tooltip>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Archive the {certificate.certification.name} certificate of {certificate.user.fullName}?</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Archived certificates only appears on the owner's profile
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this._handleArchive.bind(this, certificate, handler)} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

      </div >
    );
  }
}
CertificateTableActions.propTypes = {
  classes: PropTypes.object.isRequired,
};

const MUTATION_MARK_AS_DELETED = gql`
mutation updateCertificate($certificateId: ID!){
    updateCertificate(certificateId: $certificateId, input:{markedAsDeleted:true}){
    id
  }
}
`;

export default compose(
  graphql(MUTATION_MARK_AS_DELETED, {
    name: 'mutationMarkAsDeleted',
    options: {
      refetchQueries: ["all_certifications_query"]
    }
  }),
  withStyles(styles)
)(CertificateTableActions);


// WEBPACK FOOTER //
// src/components/innerComponents/CertificateTableActions.js